/* eslint-disable array-callback-return */
import React, { useEffect, useState } from "react";
import { styled as muiStyled } from "@mui/material/styles";
import styled, { css } from "styled-components";
import { useNavigate } from "react-router-dom";
import { getLocale } from "react-i18nify";
import { arrayMove } from "@dnd-kit/sortable";

import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
// import InputAdornment from "@mui/material/InputAdornment";
import {
  createFilterOptions,
  Autocomplete,
  FormControlLabel,
  InputAdornment,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import CloseIcon from "@mui/icons-material/Close";
import DesktopIcon from "@mui/icons-material/DesktopWindowsOutlined";
import TabletIcon from "@mui/icons-material/TabletMac";
import IphoneIcon from "@mui/icons-material/PhoneIphone";
import EditIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";
import MoveIcon from "src/components/icon/Move";
import ImageIcon from "src/components/icon/Image";
import { IconExclusiveLogo, IconWarning } from "src/icons";

import Button from "src/components/core/Button";
import TextField from "src/components/core/TextField";
import LabelSection from "src/components/core/LabelSection";
import DraggableBoard, {
  DraggableItem,
} from "src/components/core/DraggableBoard";
import Dropdown from "src/components/core/Dropdown";
import { MainSwitch } from "src/components/core/Switch";
import Loading from "src/components/ui/Loading";

import font from "src/styles/font";
import {
  Black,
  DarkGrey,
  Focused,
  Green,
  Grey,
  GreyStroke,
  Primary,
  White,
  White01,
} from "src/styles/color";
import { convertPrice } from "src/common";
import { hexToRgba } from "src/common/color";
import { useDialog } from "src/context/DialogContext";

import MetaTagComponent from "./MataTagComponent";
import AddMultiProductDialog from "./AddMultiProductDialog";
import AddBannerDialog from "./AddBannerDialog";
import AddGroupDialog from "./AddGroupDialog";
import AddSellerDialog from "./AddSellerDialog";
import EditProductDialog from "./EditProductDialog";

import {
  findAllXclusiveDeal,
  moveDealBannerPosition,
  deleteBanner,
  moveDealSellerPosition,
  moveDealGroupPosition,
  deleteGroup,
  deleteSeller,
  updateDealLanding,
  searchDealProduct,
  changeDealStatus,
} from "src/api/deal";
import { useSnackbar } from "notistack";

const WrapperTextfield = styled.div`
  width: 100%;

  .TextField-without-border-radius fieldset {
    border-radius: 16px;
    // text-align: center;
    // background: #fff;
  }
  .TextField-without-border-radius-amount fieldset {
    border-radius: 16px;
    width: 100%;
    text-align: center;
    background: #fff;
  }
  .MuiAutocomplete-root {
    margin: 0;
  }
  .MuiOutlinedInput-input {
    background: #fff;
    /* border-radius: 16px; */
    padding: 16px;
  }
  .MuiInputBase-root-MuiOutlinedInput-root {
    border-radius: 16px;
    background: #fff;
  }
  .MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
    border-radius: 16px;
  }

  .MuiTextField-root {
    border-radius: 16px;
  }
  .MuiOutlinedInput-root {
    border-radius: 16px;
  }
  .MuiInputAdornment-root {
    font-size: ${font.size.sm};
    color: ${Grey};
  }
`;

const BoxWrapper = styled.div`
  width: 100%;
  height: auto;
  padding: 32px;
  border-radius: 32px;
  background-color: #ffffff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  // display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 32px;
`;

const RecentLabel = styled.span`
  font-size: ${font.size.sm};
  font-weight: 400;
`;

const WrapperSwitch = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* align-items: center; */
  width: max-content;
`;

const SwitchLabel = styled.span`
  font-size: ${font.size.xs};
  font-weight: 400;
  color: ${DarkGrey};
  margin-bottom: 8px;
`;

const StyledSwitch = styled(MainSwitch)`
  & .MuiSwitch-switchBase {
    &.Mui-checked {
      & + .MuiSwitch-track {
        background-color: ${White01} !important;
      }
    }
    &.Mui-focusVisible .MuiSwitch-thumb {
      color: ${White01};
      border: 6px solid #fff;
    }
    & .MuiSwitch-thumb {
      background-color: ${({ checked }) =>
        checked ? `${Green}` : `${Primary}`};
    }
  }

  & .MuiSwitch-track {
    position: relative;
    background-color: ${White01} !important;

    &:before {
      position: absolute;
      top: 50%;
      color: ${Grey};
      font-size: 0.675rem;
      font-weight: 600;

      ${({ checked }) =>
        checked
          ? css`
              content: "ON";
              left: 30%;
              transform: translate(-50%, -50%);
            `
          : css`
              content: "OFF";
              right: 30%;
              transform: translate(50%, -50%);
            `}
    }
  }

  &.MuiSwitch-root:hover {
    outline: 2px solid #d3eadd;
    border-radius: 32px;

    ${({ checked }) =>
      checked
        ? css`
            outline: 2px solid #d3eadd;
          `
        : css`
            outline: 2px solid ${Focused};
          `}
  }
`;

const ToneSwitch = styled(MainSwitch)`
  &.MuiSwitch-root .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {
    background-color: ${White01};
  }
  &.MuiSwitch-root .MuiSwitch-track {
    background-color: ${Black};
  }

  & .MuiSwitch-track {
    position: relative;
    /* background-color: ${White01} !important; */

    &:before {
      position: absolute;
      top: 50%;
      color: ${Grey};
      font-size: 0.675rem;
      font-weight: 600;

      ${({ checked }) =>
        checked
          ? css`
              content: "W";
              left: 30%;
              transform: translate(-50%, -50%);
            `
          : css`
              content: "B";
              right: 30%;
              transform: translate(50%, -50%);
            `}
    }
  }

  /* &.MuiSwitch-root:hover {
    outline: 2px solid #d3eadd;
    border-radius: 32px;

    ${({ checked }) =>
    checked
      ? css`
          outline: 2px solid #d3eadd;
        `
      : css`
          outline: 2px solid ${Focused};
        `}
  } */
`;

const drawerWidth = 260;

const Main = muiStyled("main", {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  position: "relative",
  flexGrow: 1,
  padding: theme.spacing(3),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${drawerWidth}px`,
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
    position: "relative",
  }),
}));

const DrawerHeader = muiStyled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
  height: "75px",
}));

const S = {};

S.BannerListContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
`;

S.BannerItemWrapper = styled(DraggableItem)`
  position: relative;
  width: 100%;
  padding-top: calc(100% / (1440 / 540));
  background-color: #f3f1f2;
  border-radius: 16px;
  background-image: url(${(props) => props.$backgroundImage});
  background-size: cover;
  background-position: center;
`;

S.BannerItemAction = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  padding: 8px;
`;

S.BannerContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  opacity: 0;
  transition: all 0.2s;

  &:hover {
    opacity: 1;
  }
`;

const BannerWarning = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

const BannerText = styled.div`
  color: ${DarkGrey};
  font-size: ${font.size.sm};
  font-weight: 400;
`;

S.GroupListContainer = styled.div`
  display: grid;
  /* grid-template-columns: repeat(4, 1fr); */
  /* grid-template-columns: repeat(4, minmax(0px, calc((100% - 48px) / 4))); */
  grid-template-columns: repeat(4, minmax(0px, calc((100% - 48px) / 4)));
  gap: 16px;
`;

S.GroupItemWrapper = styled(DraggableItem)`
  position: relative;
  width: 100%;
  padding: 16px;
  border-radius: 16px;
  border: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
`;

S.GroupImage = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 8px;
  margin-right: 8px;
  background-image: url(${(props) => props.backgroundImg});
  background-size: cover;
  background-position: center;
`;

S.GroupName = styled.span`
  font-size: 16px;
  font-weight: 500;
  user-select: none;
  white-space: nowrap;
`;

S.GroupItemAction = styled.div`
  /* display: flex;
  align-items: center; */
  &.group-name {
    max-width: 60%;
    white-space: nowrap;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const ImageEmpty = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 56px;
  height: 56px;
  background: #f2f1f3;
  border-radius: 16px;
  object-fit: cover;
  object-position: center;
  cursor: pointer;
  vertical-align: initial;
  margin-right: 8px;
  &:hover {
    opacity: 0.8;
  }

  &.active {
    border: 2px solid #707070;
  }
`;

const TextOption = styled(Box)`
  width: 100%;
  color: ${({ color }) =>
    color === "grey"
      ? "var(--darkgrey-color)"
      : color === "primary"
        ? "var(--primary-color)"
        : "var(--secondary-color)"};
  font-size: ${font.size.sm};
  font-weight: 400;
  margin-bottom: 8px;
`;

const TextPriceOption = styled(Box)`
  width: 100%;
  color: var(--primary-color);
  font-size: ${font.size.md};
  font-weight: 500;
`;

S.PreviewImageUploadLabel = styled.div`
  position: relative;
  width: 100%;
  padding-top: calc(100% / (1440 / 798));
  background-color: ${White01};
  border-radius: 16px;
`;

S.PreviewImageFieldset = styled.fieldset`
  height: 100%;
  min-height: 150px;
  /* min-height: 120px;
  max-height: 150px; */
  border-radius: 16px;
  border: 1px solid ${Grey};
`;

S.PreviewLegend = styled.legend`
  font-size: ${font.size.xs};
  font-weight: 400;
  color: ${DarkGrey};
`;

S.PreviewImageCampangeBox = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

S.PreviewImageUploadBox = styled.div`
  position: relative;
  padding-top: 100%;
  background-color: ${White01};
  border-radius: 16px;
  /* grid-column: span 7; */
`;

S.PreviewLabelImageBox = styled.div`
  position: relative;
  padding-top: 150px;
  background-color: ${White01};
  border-radius: 16px;
  /* grid-column: span 7; */
`;

S.PreviewImage = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border-radius: inherit;
  object-fit: cover;
`;

S.LandingDataLabel = styled.div`
  font-size: ${font.size.xs};
  font-weight: 400;
  color: ${DarkGrey};
`;

S.LandingDataDetail = styled.div`
  font-size: ${font.size.md};
  font-weight: 400;
  color: ${Black};
`;

S.WrapperPreviewImageUpload = styled.div`
  width: 100%;
  height: max-content;
  /* max-height: 300px; */
  display: flex;
  align-items: center;
  justify-content: center;
`;

S.PreviewImageUploadBackgroup = styled.div`
  position: relative;
  max-width: 100%;
  height: 100%;
  padding-top: calc(100% / (1440 / 798));
  background-color: ${White01};
  border-radius: 16px;
  /* grid-column: span 7; */

  ${({ type }) =>
    type === "desktop"
      ? css`
          width: 100%;
          /* padding-top: calc(100% / (1440 / 798)); */
          /* aspect-ratio: 1440 / 798; */
        `
      : type === "tablet"
        ? css`
            /* padding-top: calc(100% / (768 / 1024)); */
            /* width: calc(100% / (1024 / 768)); */
            aspect-ratio: 768 / 1024;
          `
        : type === "mobile"
          ? css`
              /* padding-top: calc(100% / (390 / 844)); */
              /* width: calc(100% / (844 / 390)); */
              aspect-ratio: 390 / 844;
            `
          : type === "background"
            ? css`
                padding-top: calc(100% / (1440 / 996));
                width: 100%;
                /* aspect-ratio: 1440 / 996; */
              `
            : css`
                /* padding-top: 200px; */
                width: 100%;
              `}
`;

S.UploadInnerBox = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
`;

S.UploadInput = styled.label`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
`;

S.UploadLabel = styled.span`
  font-size: ${font.size.sm};
  font-weight: 500;
  color: ${DarkGrey};
  margin-top: 8px;
  text-align: center;

  &::after {
    content: "*";
    font-weight: 600;
    color: #e04132;
  }
`;

S.UploadHelperText = styled.span`
  display: flex;
  justify-content: center;
  font-size: ${font.size.xs};
  color: ${DarkGrey};
  text-align: center;
  white-space: pre-line;
  margin-top: 8px;
`;

S.WrapperUploadedPreview = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: inherit;
`;

S.UploadedPreviewImage = styled.img`
  width: 100%;
  max-width: 100px;
  height: auto;
  object-fit: cover;
`;

S.UploadImageSubTitle = styled.span`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: pre-line;
`;

S.SellerListContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 24px;
`;

S.SellerItemWrapper = styled(DraggableItem)`
  position: relative;
  width: 80px;
  padding-top: 80px;
  background-color: #f3f1f2;
  border-radius: 16px;
  background-image: url(${(props) => props.$backgroundImage});
  background-size: cover;
  background-position: center;
`;

S.RecentlyContainer = styled.div`
  width: 100%;
  margin-top: 16px;
`;

S.RecentlyItem = styled.div`
  padding: 8px 16px;
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;
  user-select: none;
  border-bottom: 1px solid ${GreyStroke};

  &:last-child {
    border-bottom: none;
  }
`;

S.RecentlyPreviewImage = styled.div`
  position: relative;
  width: 40px;
  min-width: 40px;
  padding-top: 40px;
  background-color: ${White01};
  border-radius: 8px;
`;

S.RecentlyText = styled.div`
  color: ${({ color }) => (color ? color : `${DarkGrey}`)};
  font-size: ${({ fontSize }) => (fontSize ? fontSize : `${font.size.sm}`)};
  font-weight: 400;
  line-height: 24px;

  ${({ specialPrice }) =>
    specialPrice &&
    css`
      font-size: ${font.size.md};
      font-weight: 500;
      color: ${Primary};
    `}
`;

function ExclusiveDeal({ open }) {
  const { enqueueSnackbar } = useSnackbar();
  const { openDialog, closeDialog, closeAllDialogs } = useDialog();
  const navigate = useNavigate();

  const [isProductLoading, setIsProductLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [dataProductList, setDataProductList] = useState([]);

  const [sellers, setSellers] = useState([]);
  const [banners, setBanners] = useState([]);
  const [dealGroups, setDealGroups] = useState([]);
  const [recentlyProducts, setRecentlyProducts] = useState([]);

  const [dealStatus, setDealStatus] = useState(false);
  const [dealData, setDealData] = useState({
    _id: null,
    background: null,
    splash_screen_desktop: null,
    splash_screen_tablet: null,
    splash_screen_mobile: null,
    meta_tag: {
      title: "",
      desc: "",
      img: null,
      // link: "",
      keywords: "",
    },
    section_title: "",
    label_deal_img_card: null,
    label_deal_img_detail: null,
    text_color: "black",
    status_deal: false,
  });

  // Cam section
  const [editCampaign, setEditCampaign] = useState({
    section_title: "",
    label_deal_img_card: null,
    label_deal_img_detail: null,
    text_color: "black",
  });
  const [isCampaignEdit, setIsCampaignEdit] = useState(false);
  /**
   * @check meta tag from DB is not empty for edit button
   */
  const isShowEditCampaign = [
    "section_title",
    "label_deal_img_card",
    "label_deal_img_detail",
  ].some((required) => {
    let objVal = dealData[required];
    return objVal !== null && objVal !== "" && objVal !== undefined;
  });
  /**
   * @check meta tag is edit
   */
  const isShowSubmitCampaignGroup = [
    "section_title",
    "label_deal_img_card",
    "label_deal_img_detail",
  ].some((required) => {
    let objVal = editCampaign[required];
    return objVal !== null && objVal !== "";
  });
  /**
   * @check meta tag require field is valid
   */
  const isCampaignValid = Object.keys(editCampaign).every((required) => {
    let objVal = editCampaign[required];
    return objVal !== null && objVal !== "";
  });
  // end

  // Meta tag section
  const [editMetaTag, setEditMetaTag] = useState({
    title: "",
    desc: "",
    img: null,
    keywords: "",
  });
  const [isMetaTagEdit, setIsMetaTagEdit] = useState(false);
  /**
   * @check meta tag from DB is not empty for edit button
   */
  const isShowEditMetaTag = Object.keys(dealData.meta_tag).some((required) => {
    let objVal = dealData.meta_tag[required];
    return objVal !== null && objVal !== "";
  });
  /**
   * @check meta tag is edit
   */
  const isShowSubmitMetaTagGroup = Object.keys(editMetaTag).some((required) => {
    let objVal = editMetaTag[required];
    return objVal !== null && objVal !== "";
  });
  /**
   * @check meta tag require field is valid
   */
  const isMetaTagValid = Object.keys(editMetaTag).every((required) => {
    let objVal = editMetaTag[required];
    return objVal !== null && objVal !== "";
  });
  // end

  // Splash screen section
  const [editSplashScreen, setEditSplashScreen] = useState({
    splash_screen_desktop: null,
    splash_screen_tablet: null,
    splash_screen_mobile: null,
  });
  const [isSplashScreenEdit, setIsSplashScreenEdit] = useState(false);
  /**
   * @check splash screen from DB is not empty for edit button
   */
  const isShowEditSplashScreen = [
    "splash_screen_desktop",
    "splash_screen_tablet",
    "splash_screen_mobile",
  ].some((required) => {
    let objVal = dealData[required];
    return objVal !== null && objVal !== "";
  });
  /**
   * @check splash screen is edit
   */
  const isShowSubmitSplashScreenGroup = Object.keys(editSplashScreen).some(
    (required) => {
      let objVal = editSplashScreen[required];
      return objVal !== null && objVal !== "";
    },
  );
  /**
   * @check splash screen require field is valid
   */
  const isSplashScreenValid = Object.keys(editSplashScreen).every(
    (required) => {
      let objVal = editSplashScreen[required];
      return objVal !== null && objVal !== "";
    },
  );
  // end

  // Background cover
  const [editBackground, setEditBackground] = useState(null);
  const [isBackgroundEdit, setIsBackgroundEdit] = useState(false);
  /**
   * @check backgroud cover from DB is not empty for edit button
   */
  const isShowEditBackground =
    dealData.background !== null && dealData.background !== "";
  /**
   * @check backgroud cover is current edit
   */
  const isShowSubmitBackgroundGroup =
    (editBackground !== null && editBackground !== "") || isBackgroundEdit;
  /**
   * @check splash screen require field is valid
   */
  const isBackgroundValid = editBackground !== null && editBackground !== "";
  // end

  const fetchDeals = async () => {
    try {
      setIsLoading(true);
      const result = await findAllXclusiveDeal();
      // console.log("----result----", result.data);

      const { banner, group, seller, latest_product, ...landingData } =
        result.data;

      setDealData({
        ...landingData,
      });
      setDealStatus(landingData.status_deal);
      setSellers(seller);
      setBanners(banner);
      setDealGroups(group);
      setRecentlyProducts(latest_product);

      await setIsLoading(false);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchProducts = async () => {
    try {
      setIsProductLoading(true);
      await searchDealProduct({}).then(async ({ data }) => {
        // console.log('----- data ----', data)
        setDataProductList(data);
      });
    } catch (err) {
      console.error(err);
    } finally {
      setIsProductLoading(false);
    }
  };

  const fetchChangeDealStatus = async (status) => {
    try {
      setIsLoading(true);
      await changeDealStatus(dealData._id, {
        status: status,
      });

      await enqueueSnackbar("อัพเดตสถานะสำเร็จ", {
        variant: "success",
      });

      await fetchDeals();
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleToggleDealStatus = async () => {
    // setDealStatus(!dealStatus);
    openDialog({
      type: "confirm",
      title: `คุณต้องการ${
        !dealStatus ? `เปิด` : `ปิด`
      }การมองเห็น\nXculsive Deal ใช่หรือไม่`,
      onConfirm: () => {
        fetchChangeDealStatus(!dealStatus ? "on" : "off");
        closeDialog();
      },
      maxWidth: 342,
    });
  };

  const handleDeleteBanner = async (id) => {
    try {
      await deleteBanner(id);
      await fetchDeals();
    } catch (err) {
      console.error(err);
    }
  };

  const handleEditCampaign = async () => {
    try {
      await updateDealLanding({
        ...dealData,
        section_title: editCampaign.section_title,
        label_deal_img_card: editCampaign.label_deal_img_card,
        label_deal_img_detail: editCampaign.label_deal_img_detail,
        text_color: editCampaign.text_color,
      });
      await fetchDeals();
      await setEditCampaign({
        section_title: "",
        label_deal_img_card: null,
        label_deal_img_detail: null,
        text_color: "black",
      });
      await setIsCampaignEdit(false);
      await closeDialog();
    } catch (err) {
      console.error(err);
    }
  };

  const handleEditMetaTag = async () => {
    try {
      await updateDealLanding({
        ...dealData,
        meta_tag: {
          title: editMetaTag.title,
          desc: editMetaTag.desc,
          keywords: editMetaTag.keywords,
        },
        meta_img: editMetaTag.img,
      });
      await fetchDeals();
      await setEditMetaTag({
        title: "",
        desc: "",
        img: null,
        keywords: "",
      });
      await setIsMetaTagEdit(false);
      await closeDialog();
    } catch (err) {
      console.error(err);
    }
  };

  const handleEditSplashScreen = async () => {
    try {
      await updateDealLanding({
        ...dealData,
        ...editSplashScreen,
      });
      await fetchDeals();
      await setEditSplashScreen({
        splash_screen_desktop: null,
        splash_screen_tablet: null,
        splash_screen_mobile: null,
      });
      await setIsSplashScreenEdit(false);
      await closeDialog();
    } catch (err) {
      console.error(err);
    }
  };

  const handleEditBackground = async () => {
    try {
      await updateDealLanding({
        ...dealData,
        background: editBackground,
      });
      await fetchDeals();
      await setEditBackground(null);
      await setIsBackgroundEdit(false);
      await closeDialog();
    } catch (err) {
      console.error(err);
    }
  };

  const handleDeleteGroup = async (id) => {
    try {
      setIsLoading(true);
      await deleteGroup(id);
      await fetchDeals();
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteSeller = async (id) => {
    try {
      setIsLoading(true);
      await deleteSeller(id);
      await fetchDeals();
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  // const handleSearchProducts = () => {
  //   setIsProductLoading(true);
  //   clearTimeout(handleSearchingTimeout.current);
  //   handleSearchingTimeout.current = setTimeout(async () => {
  //     await fetchProducts();
  //     setIsProductLoading(false);
  //   }, 500);
  // };

  useEffect(() => {
    fetchProducts();
    fetchDeals();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isLoading) document.body.style.overflow = "hidden";
    else document.body.style = "none";
  }, [isLoading]);

  return (
    <>
      <Main open={open}>
        <DrawerHeader />
        <BoxWrapper>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              // marginBottom: 3,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                marginRight: 2,
                gap: 1,
                width: "max-content",
                minWidth: 150,
              }}
            >
              <IconExclusiveLogo />
              <S.LandingDataDetail>XCLUSIVE Deal</S.LandingDataDetail>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                marginRight: 2,
                width: "50%",
              }}
            >
              <Autocomplete
                // freeSolo
                aria-required={true}
                getOptionSelected={(option, value) =>
                  option?.product_choice_deal?._id ===
                  value?.product_choice_deal?._id
                }
                isOptionEqualToValue={(option, value) =>
                  option?.product_choice_deal?._id ===
                  value?.product_choice_deal?._id
                }
                renderOption={(props, option) => (
                  <li
                    {...props}
                    key={`search-product-${option?.product_choice_deal?._id}`}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        py: 2,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-around",
                        gap: 2,
                      }}
                    >
                      <Box>
                        {!!option?.product_choice_deal?.group_image
                          ?.product_display_image === false ? (
                          <ImageEmpty>
                            <InsertPhotoIcon
                              sx={{
                                color: "rgba(0, 0, 0, 0.54)",
                                cursor: "pointer",
                              }}
                            />
                          </ImageEmpty>
                        ) : (
                          <img
                            style={{
                              width: "56px",
                              height: "56px",
                              objectFit: "cover",
                              objectPosition: "center",
                              borderRadius: "16px",
                              // marginRight: "8px",
                            }}
                            src={
                              option?.product_choice_deal?.group_image
                                ?.product_display_image
                                ? option?.product_choice_deal?.group_image?.product_display_image.replace(
                                    ".com",
                                    ".com/300x300",
                                  )
                                : ""
                            }
                            alt={
                              option?.product_choice_deal?.group_image
                                ?.product_display_image
                            }
                          />
                        )}
                      </Box>

                      <Box
                        sx={{
                          width: "15%",
                          maxWidth: "150px",
                        }}
                      >
                        <TextOption>
                          {option?.product_choice_deal?.product?.item_name}
                        </TextOption>

                        <TextOption color="grey" sx={{ mb: 0 }}>
                          {option?.product_choice_deal?.product?.item_code}
                        </TextOption>
                      </Box>

                      <Box
                        sx={{
                          width: "20%",
                          maxWidth: "200px",
                          textAlign: "center",
                        }}
                      >
                        <TextOption color="grey">
                          {
                            option?.product_choice_deal?.product?.user?.seller
                              ?.company_name
                          }
                        </TextOption>
                      </Box>

                      <Box
                        sx={{
                          width: "20%",
                          maxWidth: "200px",
                          textAlign: "center",
                        }}
                      >
                        <TextOption color="grey">
                          {option?.group_id?.name}
                        </TextOption>
                      </Box>

                      <Box
                        sx={{
                          width: "20%",
                          maxWidth: "200px",
                        }}
                      >
                        <TextOption color="grey">
                          {option?.product_choice_deal?.size?.quantity ===
                          "size"
                            ? `${option?.product_choice_deal?.size?.width} ${
                                getLocale() === "th"
                                  ? option?.product_choice_deal?.size
                                      ?.unit_width?.unit_th
                                  : option?.product_choice_deal?.size
                                      ?.unit_width?.unit_en
                              } x ${
                                option?.product_choice_deal?.size?.height
                              } ${
                                getLocale() === "th"
                                  ? option?.product_choice_deal?.size
                                      ?.unit_height?.unit_th
                                  : option?.product_choice_deal?.size
                                      ?.unit_height?.unit_en
                              } x ${
                                option?.product_choice_deal?.size?.thickness
                              } ${
                                getLocale() === "th"
                                  ? option?.product_choice_deal?.size
                                      ?.unit_thickness?.unit_th
                                  : option?.product_choice_deal?.size
                                      ?.unit_thickness?.unit_en
                              }`
                            : option?.product_choice_deal?.size?.quantity ===
                                "capacity"
                              ? `${
                                  option?.product_choice_deal?.size
                                    ?.capacity_size
                                } ${
                                  getLocale() === "th"
                                    ? option?.product_choice_deal?.size
                                        ?.unit_capacity?.unit_th
                                    : option?.product_choice_deal?.size
                                        ?.unit_capacity?.unit_en
                                }`
                              : getLocale() === "th"
                                ? "สินค้าสั่งทำพิเศษ"
                                : "Made by order"}
                        </TextOption>

                        <TextOption color="grey" sx={{ mb: 0 }}>
                          (
                          {getLocale() === "th"
                            ? option?.product_choice_deal?.color?.color_th
                            : option?.product_choice_deal?.color?.color_en}
                          )
                        </TextOption>
                      </Box>

                      <Box
                        sx={{
                          width: "15%",
                          maxWidth: "150px",
                          textAlign: "right",
                        }}
                      >
                        {!!option?.special_price ? (
                          <>
                            <TextOption
                              color="grey"
                              sx={{ mb: 0, textDecoration: "line-through" }}
                            >
                              {`${convertPrice(option?.price || 0)}`}
                            </TextOption>

                            <TextPriceOption>
                              {`${convertPrice(option?.special_price || 0)}`}
                            </TextPriceOption>
                          </>
                        ) : (
                          <TextOption color="grey">
                            {`${convertPrice(option?.price || 0)}`}
                          </TextOption>
                        )}
                      </Box>
                    </Box>
                  </li>
                )}
                options={dataProductList}
                value={null}
                loading={isProductLoading}
                onChange={(event, newValue) => {
                  openDialog({
                    type: "custom",
                    customDialog: (
                      <EditProductDialog
                        initialValue={newValue}
                        dealGroups={dealGroups}
                        onClose={() => closeAllDialogs()}
                        onSuccess={() => {
                          fetchDeals();
                          closeAllDialogs();
                        }}
                      />
                    ),
                  });
                }}
                getOptionLabel={(option) => {
                  return (
                    option?.product_choice_deal?.product?.item_name +
                    " - " +
                    option?.product_choice_deal?.product?.item_code +
                    (option?.product_choice_deal?.name !== ""
                      ? ` - (` + option?.product_choice_deal?.name + `)`
                      : ``) +
                    ` [${option?.product_choice_deal?.product?.user?.seller?.company_name}]`
                  );
                }}
                renderTags={(value) => null}
                filterOptions={createFilterOptions({
                  matchFrom: "any",
                  limit: 100,
                })}
                sx={{
                  // mt: 2,
                  // mb: 3,
                  width: "100%",
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    sx={{
                      maxWidth: "100%",
                      width: "100%",
                    }}
                    placeholder="ค้นหาโดย ชื่อ / รหัส / ร้านค้า"
                  />
                )}
              />
            </Box>

            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() =>
                openDialog({
                  type: "custom",
                  customDialog: (
                    <AddMultiProductDialog
                      dealGroups={dealGroups}
                      onClose={() => closeAllDialogs()}
                      onSuccess={() => {
                        fetchDeals();
                        closeAllDialogs();
                      }}
                    />
                  ),
                })
              }
              size="large"
              sx={{
                width: "20%",
                minWidth: 200,
              }}
            >
              เพิ่มสินค้า
            </Button>

            <WrapperSwitch style={{ paddingLeft: "24px", marginLeft: "auto" }}>
              <FormControlLabel
                control={
                  <StyledSwitch
                    sx={{ m: 1 }}
                    checked={dealStatus}
                    // checked={dealData.status_deal}
                    onChange={() => handleToggleDealStatus()}
                  />
                }
              />
            </WrapperSwitch>
          </Box>
        </BoxWrapper>

        {/* // * Campaign name */}
        <BoxWrapper>
          <LabelSection
            title="ชื่อแคมเปญ"
            headerStyle={{ marginBottom: "24px" }}
            {...(isShowEditCampaign &&
              !isCampaignEdit && {
                actionMenu: () => (
                  <Button
                    startIcon={<EditIcon />}
                    variant="secondary"
                    size="large"
                    sx={{
                      minWidth: 200,
                    }}
                    onClick={() => {
                      setIsCampaignEdit(true);
                      setEditCampaign({
                        section_title: dealData.section_title,
                        label_deal_img_card: dealData.label_deal_img_card,
                        label_deal_img_detail: dealData.label_deal_img_detail,
                        text_color: dealData.text_color,
                      });
                    }}
                  >
                    แก้ไข
                  </Button>
                ),
              })}
          >
            {isShowEditCampaign && !isCampaignEdit ? (
              <Grid container spacing={3}>
                <Grid
                  item
                  xs={6}
                  lg={7}
                  xl={8}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 3,
                  }}
                >
                  <Stack columnGap={1}>
                    <S.LandingDataLabel>ชื่อแคมเปญ</S.LandingDataLabel>
                    <S.LandingDataDetail>
                      {dealData.section_title}
                    </S.LandingDataDetail>
                  </Stack>

                  <Stack columnGap={1}>
                    <S.LandingDataLabel>สีตัวอักษร</S.LandingDataLabel>
                    <S.LandingDataDetail>
                      {dealData.text_color === "black" ? "ดำ" : "ขาว"}
                    </S.LandingDataDetail>
                  </Stack>
                </Grid>

                <Grid item xs={3} lg={2.5} xl={2}>
                  <S.PreviewImageFieldset>
                    <S.PreviewLegend>โลโก้แคมเปญ</S.PreviewLegend>

                    <S.PreviewImageCampangeBox>
                      <S.UploadedPreviewImage
                        src={
                          !!dealData.label_deal_img_card
                            ? typeof dealData.label_deal_img_card === "string"
                              ? dealData.label_deal_img_card
                              : URL.createObjectURL(
                                  dealData.label_deal_img_card,
                                )
                            : ""
                        }
                        alt=""
                      />
                    </S.PreviewImageCampangeBox>
                  </S.PreviewImageFieldset>
                </Grid>

                <Grid item xs={3} lg={2.5} xl={2}>
                  <S.PreviewImageFieldset>
                    <S.PreviewLegend>ปุ่มกดแคมเปญ</S.PreviewLegend>

                    <S.PreviewImageCampangeBox>
                      <S.UploadedPreviewImage
                        src={
                          !!dealData.label_deal_img_detail
                            ? typeof dealData.label_deal_img_detail === "string"
                              ? dealData.label_deal_img_detail
                              : URL.createObjectURL(
                                  dealData.label_deal_img_detail,
                                )
                            : ""
                        }
                        alt=""
                      />
                    </S.PreviewImageCampangeBox>
                  </S.PreviewImageFieldset>
                </Grid>
              </Grid>
            ) : (
              <Grid container spacing={3}>
                <Grid
                  item
                  xs={6}
                  lg={7}
                  xl={8}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 3,
                  }}
                >
                  <WrapperTextfield>
                    <TextField
                      label="ชื่อแคมเปญ"
                      variant="outlined"
                      required
                      value={editCampaign?.section_title}
                      onChange={(e) =>
                        setEditCampaign({
                          ...editCampaign,
                          section_title: e.target.value,
                        })
                      }
                      fullWidth
                      inputProps={{ maxLength: 20 }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            {editCampaign?.section_title?.length}/20
                          </InputAdornment>
                        ),
                      }}
                      error={!editCampaign?.section_title}
                    />
                  </WrapperTextfield>

                  <WrapperSwitch>
                    <SwitchLabel>โทนสี</SwitchLabel>
                    <FormControlLabel
                      control={
                        <ToneSwitch
                          sx={{ m: 1 }}
                          checked={
                            editCampaign.text_color === "white" ? true : false
                          }
                          onChange={(e) => {
                            setEditCampaign({
                              ...editCampaign,
                              text_color: e.target.checked ? "white" : "black",
                            });
                          }}
                        />
                      }
                    />
                  </WrapperSwitch>
                </Grid>

                <Grid item xs={3} lg={2.5} xl={2}>
                  <S.PreviewLabelImageBox>
                    {!editCampaign?.label_deal_img_card ? (
                      <S.UploadInnerBox>
                        <Stack flexDirection={"row"}>
                          <input
                            id="labelCardFieldHandle"
                            type="file"
                            accept=".jpg,.jpeg,.png"
                            style={{ display: "none" }}
                            onChange={(e) => {
                              e.preventDefault();
                              setEditCampaign({
                                ...editCampaign,
                                label_deal_img_card: e.target.files[0],
                              });
                            }}
                            onClick={(e) => (e.currentTarget.value = null)}
                          />
                          <S.UploadInput htmlFor="labelCardFieldHandle">
                            <ImageIcon size={24} color="#6C6C70" />
                            <S.UploadLabel>อัปโหลดรูปภาพ</S.UploadLabel>
                            <S.UploadHelperText>
                              {`รูปภาพขนาด 76x20 px\nขนาดไฟล์สูงสุดไม่เกิน 4 MB`}
                            </S.UploadHelperText>
                          </S.UploadInput>
                        </Stack>
                      </S.UploadInnerBox>
                    ) : (
                      <>
                        <S.WrapperUploadedPreview>
                          <S.UploadedPreviewImage
                            src={
                              typeof editCampaign?.label_deal_img_card ===
                              "string"
                                ? editCampaign?.label_deal_img_card
                                : URL.createObjectURL(
                                    editCampaign?.label_deal_img_card,
                                  )
                            }
                            alt=""
                          />
                        </S.WrapperUploadedPreview>
                        <Stack
                          sx={{
                            position: "absolute",
                            top: 6,
                            right: 6,
                          }}
                          flexDirection={"row"}
                          columnGap={1}
                        >
                          <IconButton
                            sx={{
                              padding: "4px",
                              backgroundColor: "#BCBCC0bd",
                            }}
                            onClick={() => {
                              setEditCampaign({
                                ...editCampaign,
                                label_deal_img_card: null,
                              });
                            }}
                          >
                            <CloseIcon sx={{ color: "#ffffff" }} />
                          </IconButton>
                        </Stack>
                      </>
                    )}
                  </S.PreviewLabelImageBox>
                  <S.UploadImageSubTitle
                    style={{ marginTop: 16, textAlign: "center" }}
                  >
                    {`โลโก้ขนาด 76x20 px\nขนาดไฟล์สูงสุดไม่เกิน 4 MB`}
                  </S.UploadImageSubTitle>
                </Grid>

                <Grid item xs={3} lg={2.5} xl={2}>
                  <S.PreviewLabelImageBox>
                    {!editCampaign?.label_deal_img_detail ? (
                      <S.UploadInnerBox>
                        <Stack flexDirection={"row"}>
                          <input
                            id="labelDetailFieldHandle"
                            type="file"
                            accept=".jpg,.jpeg,.png"
                            style={{ display: "none" }}
                            onChange={(e) => {
                              e.preventDefault();
                              setEditCampaign({
                                ...editCampaign,
                                label_deal_img_detail: e.target.files[0],
                              });
                            }}
                            onClick={(e) => (e.currentTarget.value = null)}
                          />
                          <S.UploadInput htmlFor="labelDetailFieldHandle">
                            <ImageIcon size={24} color="#6C6C70" />
                            <S.UploadLabel>อัปโหลดรูปภาพ</S.UploadLabel>
                            <S.UploadHelperText>
                              {`รูปภาพขนาด 115x68 px\nขนาดไฟล์สูงสุดไม่เกิน 4 MB`}
                            </S.UploadHelperText>
                          </S.UploadInput>
                        </Stack>
                      </S.UploadInnerBox>
                    ) : (
                      <>
                        <S.WrapperUploadedPreview>
                          <S.UploadedPreviewImage
                            src={
                              typeof editCampaign?.label_deal_img_detail ===
                              "string"
                                ? editCampaign?.label_deal_img_detail
                                : URL.createObjectURL(
                                    editCampaign?.label_deal_img_detail,
                                  )
                            }
                            alt=""
                          />
                        </S.WrapperUploadedPreview>
                        <Stack
                          sx={{
                            position: "absolute",
                            top: 6,
                            right: 6,
                          }}
                          flexDirection={"row"}
                          columnGap={1}
                        >
                          <IconButton
                            sx={{
                              padding: "4px",
                              backgroundColor: "#BCBCC0bd",
                            }}
                            onClick={() => {
                              setEditCampaign({
                                ...editCampaign,
                                label_deal_img_detail: null,
                              });
                            }}
                          >
                            <CloseIcon sx={{ color: "#ffffff" }} />
                          </IconButton>
                        </Stack>
                      </>
                    )}
                  </S.PreviewLabelImageBox>
                  <S.UploadImageSubTitle
                    style={{ marginTop: 16, textAlign: "center" }}
                  >
                    {`โลโก้ขนาด 115x68 px\nขนาดไฟล์สูงสุดไม่เกิน 4 MB`}
                  </S.UploadImageSubTitle>
                </Grid>
              </Grid>
            )}
          </LabelSection>

          {(isShowSubmitCampaignGroup || isCampaignEdit) && (
            <Stack
              display="flex"
              flexDirection="row"
              alignItems="center"
              justifyContent="flex-end"
              gap={3}
            >
              <Button
                variant="outlined"
                size="large"
                onClick={() => {
                  openDialog({
                    type: "confirm",
                    title: `คุณต้องการยกเลิกการแก้ไขใช่หรือไม่?`,
                    onConfirm: () => {
                      setEditCampaign({
                        section_title: "",
                        label_deal_img_card: null,
                        label_deal_img_detail: null,
                        text_color: "black",
                      });
                      setIsCampaignEdit(false);
                      closeDialog();
                    },
                    maxWidth: 342,
                  });
                }}
                sx={{
                  minWidth: 160,
                }}
              >
                ยกเลิก
              </Button>
              <Button
                variant="contained"
                size="large"
                onClick={() => {
                  openDialog({
                    type: "confirm",
                    title: `คุณต้องการบันทึกการแก้ไขใช่หรือไม่`,
                    onConfirm: () => {
                      handleEditCampaign();
                    },
                    maxWidth: 342,
                  });
                }}
                sx={{
                  minWidth: 160,
                }}
                // autoFocus // enable auto focus to increase accessibility
                disabled={!isCampaignValid}
              >
                บันทึก
              </Button>
            </Stack>
          )}
        </BoxWrapper>

        {/*//* Banner */}
        <BoxWrapper>
          <LabelSection
            title="แบนเนอร์หลัก"
            description="คุณสามารถลากแบนเนอร์เพื่อสลับตำแหน่งได้"
            descIcon={<MoveIcon size={24} />}
            {...(banners.length < 12 && {
              actionMenu: () => (
                <Button
                  startIcon={<AddIcon />}
                  variant="secondary"
                  size="large"
                  disabled={banners.length >= 12}
                  sx={{
                    minWidth: 200,
                  }}
                  onClick={() => {
                    openDialog({
                      type: "custom",
                      customDialog: (
                        <AddBannerDialog
                          onClose={() => closeDialog()}
                          onSuccess={() => {
                            fetchDeals();
                            closeAllDialogs();
                          }}
                        />
                      ),
                    });
                  }}
                >
                  เพิ่มแบนเนอร์
                </Button>
              ),
            })}
          >
            <DraggableBoard
              items={banners}
              onDragEnd={async ({ active, over }) => {
                if (active.id !== over?.id) {
                  const oldIndex = banners.findIndex(
                    (item) => item._id === active.id,
                  );
                  const newIndex = banners.findIndex(
                    (item) => item._id === over.id,
                  );

                  const newReArranged = arrayMove(banners, oldIndex, newIndex);

                  setBanners(newReArranged); // optimistic update

                  try {
                    await moveDealBannerPosition(newReArranged);
                  } catch (err) {
                    setBanners(newReArranged); // if error, revert to original order
                    console.error(err);
                  }
                }
              }}
              Components={{
                DroppableParent: ({ items, children }) => {
                  return (
                    <S.BannerListContainer>
                      {children({ items })}
                    </S.BannerListContainer>
                  );
                },
                DraggableItem: (props) => {
                  const { items, item, ...rest } = props; // Destructuring items to prevent this spreading to html element
                  return (
                    <S.BannerItemWrapper $backgroundImage={item?.url} {...rest}>
                      <S.BannerContainer>
                        <S.BannerItemAction>
                          <IconButton
                            sx={{
                              color: White,
                              backgroundColor: hexToRgba(White, 0.4),
                            }}
                            onClick={() => {
                              openDialog({
                                type: "confirm",
                                title: "คุณต้องการลบใช่หรือไม่?",
                                onConfirm: () => {
                                  handleDeleteBanner(item?._id);
                                  closeDialog();
                                },
                                maxWidth: 342,
                              });
                            }}
                          >
                            <DeleteOutlineRoundedIcon />
                          </IconButton>
                        </S.BannerItemAction>
                      </S.BannerContainer>
                    </S.BannerItemWrapper>
                  );
                },
              }}
            />
          </LabelSection>

          <BannerWarning>
            <IconWarning />
            <BannerText>
              เพิ่มแบนเนอร์ได้สูงสุด 12 รูป ขนาดไฟล์ 1440x540 px ไม่เกิน 4 MB
            </BannerText>
          </BannerWarning>
        </BoxWrapper>

        {/* //* Metatag */}
        <BoxWrapper>
          <LabelSection
            title="Metatag"
            headerStyle={{ marginBottom: "24px" }}
            {...(isShowEditMetaTag &&
              !isMetaTagEdit && {
                actionMenu: () => (
                  <Button
                    startIcon={<EditIcon />}
                    variant="secondary"
                    size="large"
                    sx={{
                      minWidth: 200,
                    }}
                    onClick={() => {
                      setIsMetaTagEdit(true);
                      setEditMetaTag(dealData.meta_tag);
                    }}
                  >
                    แก้ไข
                  </Button>
                ),
              })}
          >
            {isShowEditMetaTag && !isMetaTagEdit ? (
              <Grid container>
                <Grid
                  item
                  xs={9}
                  md={9.5}
                  sx={{
                    pr: 3,
                    display: "flex",
                    flexDirection: "column",
                    gap: 3,
                  }}
                >
                  <Stack columnGap={1}>
                    <S.LandingDataLabel>หัวเรื่อง</S.LandingDataLabel>
                    <S.LandingDataDetail>
                      {dealData.meta_tag?.title}
                    </S.LandingDataDetail>
                  </Stack>

                  <Stack columnGap={1}>
                    <S.LandingDataLabel>รายละเอียด</S.LandingDataLabel>
                    <S.LandingDataDetail>
                      {dealData.meta_tag?.desc}
                    </S.LandingDataDetail>
                  </Stack>

                  <Stack columnGap={1}>
                    <S.LandingDataLabel>คีย์เวิร์ด</S.LandingDataLabel>
                    <S.LandingDataDetail>
                      {dealData.meta_tag?.keywords}
                    </S.LandingDataDetail>
                  </Stack>
                </Grid>

                <Grid item xs={3} md={2.5}>
                  <S.PreviewImageUploadBox>
                    <S.PreviewImage
                      src={
                        !!dealData.meta_tag?.img
                          ? typeof dealData.meta_tag?.img === "string"
                            ? dealData.meta_tag?.img
                            : URL.createObjectURL(dealData.meta_tag?.img)
                          : ""
                      }
                      alt=""
                    />
                  </S.PreviewImageUploadBox>
                </Grid>
              </Grid>
            ) : (
              <MetaTagComponent
                keyImg="dealMetaTagFieldHandle"
                metatagData={editMetaTag}
                setMetatagData={setEditMetaTag}
                isEdit={isMetaTagEdit}
              />
            )}
          </LabelSection>

          {(isShowSubmitMetaTagGroup || isMetaTagEdit) && (
            <Stack
              display="flex"
              flexDirection="row"
              alignItems="center"
              justifyContent="flex-end"
              gap={3}
            >
              <Button
                variant="outlined"
                size="large"
                onClick={() => {
                  openDialog({
                    type: "confirm",
                    title: `คุณต้องการยกเลิกการแก้ไขใช่หรือไม่?`,
                    onConfirm: () => {
                      setEditMetaTag({
                        title: "",
                        desc: "",
                        img: null,
                        keywords: "",
                      });
                      setIsMetaTagEdit(false);
                      closeDialog();
                    },
                    maxWidth: 342,
                  });
                }}
                sx={{
                  minWidth: 160,
                }}
              >
                ยกเลิก
              </Button>
              <Button
                variant="contained"
                size="large"
                onClick={() => {
                  openDialog({
                    type: "confirm",
                    title: `คุณต้องการบันทึกการแก้ไขใช่หรือไม่`,
                    onConfirm: () => {
                      handleEditMetaTag();
                    },
                    maxWidth: 342,
                  });
                }}
                sx={{
                  minWidth: 160,
                }}
                // autoFocus // enable auto focus to increase accessibility
                disabled={!isMetaTagValid}
              >
                บันทึก
              </Button>
            </Stack>
          )}
        </BoxWrapper>

        {/* //* Splash screen */}
        <BoxWrapper>
          <LabelSection
            title="Splash screen"
            headerStyle={{ marginBottom: "24px" }}
            {...(isShowEditSplashScreen &&
              !isSplashScreenEdit && {
                actionMenu: () => (
                  <Button
                    startIcon={<EditIcon />}
                    variant="secondary"
                    size="large"
                    sx={{
                      minWidth: 200,
                    }}
                    onClick={() => {
                      setIsSplashScreenEdit(true);
                      setEditSplashScreen({
                        splash_screen_desktop: dealData.splash_screen_desktop,
                        splash_screen_tablet: dealData.splash_screen_tablet,
                        splash_screen_mobile: dealData.splash_screen_mobile,
                      });
                    }}
                  >
                    แก้ไข
                  </Button>
                ),
              })}
          >
            {isShowEditSplashScreen && !isSplashScreenEdit ? (
              <Grid container>
                <Grid item xs={4}>
                  <Stack alignItems="center" gap={2}>
                    <S.WrapperPreviewImageUpload>
                      <S.PreviewImageUploadBackgroup type="desktop">
                        <S.PreviewImage
                          src={
                            typeof dealData?.splash_screen_desktop === "string"
                              ? dealData?.splash_screen_desktop
                              : URL.createObjectURL(
                                  dealData?.splash_screen_desktop,
                                )
                          }
                          // src={`https://devimage.xsurface.com/mood_1709203515396_777132be9640.jpeg`}
                          alt=""
                        />
                      </S.PreviewImageUploadBackgroup>
                    </S.WrapperPreviewImageUpload>
                    <S.UploadImageSubTitle>
                      <DesktopIcon />
                      Desktop size 1440x798 px ไม่เกิน 4 MB
                    </S.UploadImageSubTitle>
                  </Stack>
                </Grid>

                <Grid item xs={4}>
                  <Stack alignItems="center" gap={2}>
                    <S.WrapperPreviewImageUpload>
                      <S.PreviewImageUploadBackgroup type="tablet">
                        <S.PreviewImage
                          src={
                            typeof dealData?.splash_screen_tablet === "string"
                              ? dealData?.splash_screen_tablet
                              : URL.createObjectURL(
                                  dealData?.splash_screen_tablet,
                                )
                          }
                          // src={`https://devimage.xsurface.com/mood_1709203515396_777132be9640.jpeg`}
                          alt=""
                        />
                      </S.PreviewImageUploadBackgroup>
                    </S.WrapperPreviewImageUpload>
                    <S.UploadImageSubTitle>
                      <TabletIcon />
                      Tablet size 768x1024 px ไม่เกิน 4 MB
                    </S.UploadImageSubTitle>
                  </Stack>
                </Grid>

                <Grid item xs={4}>
                  <Stack alignItems="center" gap={2}>
                    <S.WrapperPreviewImageUpload>
                      <S.PreviewImageUploadBackgroup type="mobile">
                        <S.PreviewImage
                          src={
                            typeof dealData?.splash_screen_mobile === "string"
                              ? dealData?.splash_screen_mobile
                              : URL.createObjectURL(
                                  dealData?.splash_screen_mobile,
                                )
                          }
                          // src={`https://devimage.xsurface.com/mood_1709203515396_777132be9640.jpeg`}
                          alt=""
                        />
                      </S.PreviewImageUploadBackgroup>
                    </S.WrapperPreviewImageUpload>
                    <S.UploadImageSubTitle>
                      <IphoneIcon />
                      Mobile size 390x844 px ไม่เกิน 4 MB
                    </S.UploadImageSubTitle>
                  </Stack>
                </Grid>
              </Grid>
            ) : (
              <Grid container>
                <Grid item xs={4}>
                  <Stack alignItems="center" gap={2}>
                    <S.WrapperPreviewImageUpload>
                      <S.PreviewImageUploadBackgroup type="desktop">
                        {!editSplashScreen?.splash_screen_desktop ? (
                          <S.UploadInnerBox>
                            <Stack flexDirection={"row"}>
                              <input
                                id="splashDesktopFieldHandle"
                                type="file"
                                accept=".jpg,.jpeg,.png"
                                style={{ display: "none" }}
                                onChange={(e) => {
                                  e.preventDefault();
                                  setEditSplashScreen({
                                    ...editSplashScreen,
                                    splash_screen_desktop: e.target.files[0],
                                  });
                                }}
                                onClick={(e) => (e.currentTarget.value = null)}
                              />
                              <S.UploadInput htmlFor="splashDesktopFieldHandle">
                                <ImageIcon size={24} color={DarkGrey} />
                                <S.UploadLabel>อัปโหลดรูปภาพ</S.UploadLabel>
                                <S.UploadHelperText>
                                  {`รูปภาพขนาด 1440x798 px\nขนาดไฟล์สูงสุดไม่เกิน 4 MB`}
                                </S.UploadHelperText>
                              </S.UploadInput>
                            </Stack>
                          </S.UploadInnerBox>
                        ) : (
                          <>
                            <S.PreviewImage
                              src={
                                typeof editSplashScreen?.splash_screen_desktop ===
                                "string"
                                  ? editSplashScreen?.splash_screen_desktop
                                  : URL.createObjectURL(
                                      editSplashScreen?.splash_screen_desktop,
                                    )
                              }
                              alt=""
                            />
                            <Stack
                              sx={{
                                position: "absolute",
                                top: 6,
                                right: 6,
                              }}
                              flexDirection={"row"}
                              columnGap={1}
                            >
                              <IconButton
                                sx={{
                                  padding: "4px",
                                  backgroundColor: "#BCBCC0bd",
                                }}
                                onClick={() => {
                                  setEditSplashScreen({
                                    ...editSplashScreen,
                                    splash_screen_desktop: null,
                                  });
                                }}
                              >
                                <CloseIcon sx={{ color: "#ffffff" }} />
                              </IconButton>
                            </Stack>
                          </>
                        )}
                      </S.PreviewImageUploadBackgroup>
                    </S.WrapperPreviewImageUpload>
                    <S.UploadImageSubTitle>
                      <DesktopIcon />
                      Desktop size 1440x798 px ไม่เกิน 4 MB
                    </S.UploadImageSubTitle>
                  </Stack>
                </Grid>

                <Grid item xs={4}>
                  <Stack alignItems="center" gap={2}>
                    <S.WrapperPreviewImageUpload>
                      <S.PreviewImageUploadBackgroup type="tablet">
                        {!editSplashScreen?.splash_screen_tablet ? (
                          <S.UploadInnerBox>
                            <Stack flexDirection={"row"}>
                              <input
                                id="splashTabletFieldHandle"
                                type="file"
                                accept=".jpg,.jpeg,.png"
                                style={{ display: "none" }}
                                onChange={(e) => {
                                  e.preventDefault();
                                  setEditSplashScreen({
                                    ...editSplashScreen,
                                    splash_screen_tablet: e.target.files[0],
                                  });
                                }}
                                onClick={(e) => (e.currentTarget.value = null)}
                              />
                              <S.UploadInput htmlFor="splashTabletFieldHandle">
                                <ImageIcon size={24} color={DarkGrey} />
                                <S.UploadLabel>อัปโหลดรูปภาพ</S.UploadLabel>
                                <S.UploadHelperText>
                                  {`รูปภาพขนาด 768x1024 px\nขนาดไฟล์สูงสุดไม่เกิน 4 MB`}
                                </S.UploadHelperText>
                              </S.UploadInput>
                            </Stack>
                          </S.UploadInnerBox>
                        ) : (
                          <>
                            <S.PreviewImage
                              src={
                                typeof editSplashScreen?.splash_screen_tablet ===
                                "string"
                                  ? editSplashScreen?.splash_screen_tablet
                                  : URL.createObjectURL(
                                      editSplashScreen?.splash_screen_tablet,
                                    )
                              }
                              alt=""
                            />
                            <Stack
                              sx={{
                                position: "absolute",
                                top: 6,
                                right: 6,
                              }}
                              flexDirection={"row"}
                              columnGap={1}
                            >
                              <IconButton
                                sx={{
                                  padding: "4px",
                                  backgroundColor: "#BCBCC0bd",
                                }}
                                onClick={() => {
                                  setEditSplashScreen({
                                    ...editSplashScreen,
                                    splash_screen_tablet: null,
                                  });
                                }}
                              >
                                <CloseIcon sx={{ color: "#ffffff" }} />
                              </IconButton>
                            </Stack>
                          </>
                        )}
                      </S.PreviewImageUploadBackgroup>
                    </S.WrapperPreviewImageUpload>
                    <S.UploadImageSubTitle>
                      <TabletIcon />
                      Tablet size 768x1024 px ไม่เกิน 4 MB
                    </S.UploadImageSubTitle>
                  </Stack>
                </Grid>

                <Grid item xs={4}>
                  <Stack alignItems="center" gap={2}>
                    <S.WrapperPreviewImageUpload>
                      <S.PreviewImageUploadBackgroup type="mobile">
                        {!editSplashScreen?.splash_screen_mobile ? (
                          <S.UploadInnerBox>
                            <Stack flexDirection={"row"}>
                              <input
                                id="splashMobileFieldHandle"
                                type="file"
                                accept=".jpg,.jpeg,.png"
                                style={{ display: "none" }}
                                onChange={(e) => {
                                  e.preventDefault();
                                  setEditSplashScreen({
                                    ...editSplashScreen,
                                    splash_screen_mobile: e.target.files[0],
                                  });
                                }}
                                onClick={(e) => (e.currentTarget.value = null)}
                              />
                              <S.UploadInput htmlFor="splashMobileFieldHandle">
                                <ImageIcon size={24} color={DarkGrey} />
                                <S.UploadLabel>อัปโหลดรูปภาพ</S.UploadLabel>
                                <S.UploadHelperText>
                                  {`รูปภาพขนาด 390x844 px ขนาดไฟล์สูงสุดไม่เกิน 4 MB`}
                                </S.UploadHelperText>
                              </S.UploadInput>
                            </Stack>
                          </S.UploadInnerBox>
                        ) : (
                          <>
                            <S.PreviewImage
                              src={
                                typeof editSplashScreen?.splash_screen_mobile ===
                                "string"
                                  ? editSplashScreen?.splash_screen_mobile
                                  : URL.createObjectURL(
                                      editSplashScreen?.splash_screen_mobile,
                                    )
                              }
                              alt=""
                            />
                            <Stack
                              sx={{
                                position: "absolute",
                                top: 6,
                                right: 6,
                              }}
                              flexDirection={"row"}
                              columnGap={1}
                            >
                              <IconButton
                                sx={{
                                  padding: "4px",
                                  backgroundColor: "#BCBCC0bd",
                                }}
                                onClick={() => {
                                  setEditSplashScreen({
                                    ...editSplashScreen,
                                    splash_screen_mobile: null,
                                  });
                                }}
                              >
                                <CloseIcon sx={{ color: "#ffffff" }} />
                              </IconButton>
                            </Stack>
                          </>
                        )}
                      </S.PreviewImageUploadBackgroup>
                    </S.WrapperPreviewImageUpload>
                    <S.UploadImageSubTitle>
                      <IphoneIcon />
                      Mobile size 390x844 px ไม่เกิน 4 MB
                    </S.UploadImageSubTitle>
                  </Stack>
                </Grid>
              </Grid>
            )}
          </LabelSection>

          {(isShowSubmitSplashScreenGroup || isSplashScreenEdit) && (
            <Stack
              display="flex"
              flexDirection="row"
              alignItems="center"
              justifyContent="flex-end"
              gap={3}
            >
              <Button
                variant="outlined"
                size="large"
                onClick={() => {
                  openDialog({
                    type: "confirm",
                    title: `คุณต้องการยกเลิกการแก้ไขใช่หรือไม่?`,
                    onConfirm: () => {
                      setEditSplashScreen({
                        splash_screen_desktop: null,
                        splash_screen_tablet: null,
                        splash_screen_mobile: null,
                      });
                      setIsSplashScreenEdit(false);
                      closeDialog();
                    },
                    maxWidth: 342,
                  });
                }}
                sx={{
                  minWidth: 160,
                }}
              >
                ยกเลิก
              </Button>
              <Button
                variant="contained"
                size="large"
                onClick={() => {
                  openDialog({
                    type: "confirm",
                    title: `คุณต้องการบันทึกการแก้ไขใช่หรือไม่`,
                    onConfirm: () => {
                      handleEditSplashScreen();
                    },
                    maxWidth: 342,
                  });
                }}
                sx={{
                  minWidth: 160,
                }}
                // autoFocus // enable auto focus to increase accessibility
                disabled={!isSplashScreenValid}
              >
                บันทึก
              </Button>
            </Stack>
          )}
        </BoxWrapper>

        {/* //* Background cover */}
        <BoxWrapper>
          <LabelSection
            title="Background cover"
            headerStyle={{ marginBottom: "24px" }}
            {...(isShowEditBackground &&
              !isBackgroundEdit && {
                actionMenu: () => (
                  <Button
                    startIcon={<EditIcon />}
                    variant="secondary"
                    size="large"
                    sx={{
                      minWidth: 200,
                    }}
                    onClick={() => {
                      setIsBackgroundEdit(true);
                      setEditBackground(dealData.background);
                    }}
                  >
                    แก้ไข
                  </Button>
                ),
              })}
          >
            {isShowEditBackground && !isBackgroundEdit ? (
              <Grid container justifyContent="center">
                <Grid item xs={6}>
                  <Stack alignItems="center" gap={2}>
                    <S.WrapperPreviewImageUpload>
                      <S.PreviewImageUploadBackgroup type="background">
                        <S.PreviewImage
                          src={
                            typeof dealData?.background === "string"
                              ? dealData?.background
                              : URL.createObjectURL(dealData?.background)
                          }
                          alt=""
                        />
                      </S.PreviewImageUploadBackgroup>
                    </S.WrapperPreviewImageUpload>
                    <S.UploadImageSubTitle>
                      <DesktopIcon />
                      Desktop size 1440x996 px ไม่เกิน 4 MB
                    </S.UploadImageSubTitle>
                  </Stack>
                </Grid>
              </Grid>
            ) : (
              <Grid container justifyContent="center">
                <Grid item xs={6}>
                  <Stack alignItems="center" gap={2}>
                    <S.WrapperPreviewImageUpload>
                      <S.PreviewImageUploadBackgroup type="background">
                        {!editBackground ? (
                          <S.UploadInnerBox>
                            <Stack flexDirection={"row"}>
                              <input
                                id="backgroundCoverFieldHandle"
                                type="file"
                                accept=".jpg,.jpeg,.png"
                                style={{ display: "none" }}
                                onChange={(e) => {
                                  e.preventDefault();
                                  setEditBackground(e.target.files[0]);
                                }}
                                onClick={(e) => (e.currentTarget.value = null)}
                              />
                              <S.UploadInput htmlFor="backgroundCoverFieldHandle">
                                <ImageIcon size={24} color={DarkGrey} />
                                <S.UploadLabel>อัปโหลดรูปภาพ</S.UploadLabel>
                                <S.UploadHelperText>
                                  {`รูปภาพขนาด 1440x996 px\nขนาดไฟล์สูงสุดไม่เกิน 4 MB`}
                                </S.UploadHelperText>
                              </S.UploadInput>
                            </Stack>
                          </S.UploadInnerBox>
                        ) : (
                          <>
                            <S.PreviewImage
                              src={
                                typeof editBackground === "string"
                                  ? editBackground
                                  : URL.createObjectURL(editBackground)
                              }
                              alt=""
                            />
                            <Stack
                              sx={{
                                position: "absolute",
                                top: 6,
                                right: 6,
                              }}
                              flexDirection={"row"}
                              columnGap={1}
                            >
                              <IconButton
                                sx={{
                                  padding: "4px",
                                  backgroundColor: "#BCBCC0bd",
                                }}
                                onClick={() => {
                                  setEditBackground(null);
                                }}
                              >
                                <CloseIcon sx={{ color: "#ffffff" }} />
                              </IconButton>
                            </Stack>
                          </>
                        )}
                      </S.PreviewImageUploadBackgroup>
                    </S.WrapperPreviewImageUpload>
                    <S.UploadImageSubTitle>
                      <DesktopIcon />
                      Desktop size 1440x996 px ไม่เกิน 4 MB
                    </S.UploadImageSubTitle>
                  </Stack>
                </Grid>
              </Grid>
            )}
          </LabelSection>

          {isShowSubmitBackgroundGroup && (
            <Stack
              display="flex"
              flexDirection="row"
              alignItems="center"
              justifyContent="flex-end"
              gap={3}
            >
              <Button
                variant="outlined"
                size="large"
                onClick={() => {
                  openDialog({
                    type: "confirm",
                    title: `คุณต้องการยกเลิกการแก้ไขใช่หรือไม่?`,
                    onConfirm: () => {
                      setEditBackground(null);
                      setIsBackgroundEdit(false);
                      closeDialog();
                    },
                    maxWidth: 342,
                  });
                }}
                sx={{
                  minWidth: 160,
                }}
              >
                ยกเลิก
              </Button>
              <Button
                variant="contained"
                size="large"
                onClick={() => {
                  openDialog({
                    type: "confirm",
                    title: `คุณต้องการบันทึกการแก้ไขใช่หรือไม่`,
                    onConfirm: () => {
                      handleEditBackground();
                    },
                    maxWidth: 342,
                  });
                }}
                sx={{
                  minWidth: 160,
                }}
                // autoFocus // enable auto focus to increase accessibility
                disabled={!isBackgroundValid}
              >
                บันทึก
              </Button>
            </Stack>
          )}
        </BoxWrapper>

        {/* //* Group */}
        <BoxWrapper>
          <LabelSection
            title="หมวดหมู่"
            description="คุณสามารถลากหมวดหมู่เพื่อสลับตำแหน่งได้"
            descIcon={<MoveIcon size={24} />}
            actionMenu={() => (
              <Button
                startIcon={<AddIcon />}
                variant="secondary"
                size="large"
                sx={{
                  minWidth: 200,
                }}
                onClick={() => {
                  openDialog({
                    type: "custom",
                    customDialog: (
                      <AddGroupDialog
                        onClose={() => closeAllDialogs()}
                        onSuccess={() => {
                          fetchDeals();
                          closeAllDialogs();
                        }}
                      />
                    ),
                  });
                }}
              >
                เพิ่มหมวดหมู่
              </Button>
            )}
          >
            <DraggableBoard
              items={dealGroups}
              onDragEnd={async ({ active, over }) => {
                if (active.id !== over?.id) {
                  const oldIndex = dealGroups.findIndex(
                    (item) => item._id === active.id,
                  );
                  const newIndex = dealGroups.findIndex(
                    (item) => item._id === over.id,
                  );

                  const newReArranged = arrayMove(
                    dealGroups,
                    oldIndex,
                    newIndex,
                  );

                  setDealGroups(newReArranged); // optimistic update

                  try {
                    await moveDealGroupPosition(newReArranged);
                  } catch (err) {
                    setDealGroups(newReArranged); // if error, revert to original order
                    console.error(err);
                  }
                }
              }}
              Components={{
                DroppableParent: ({ items, children }) => {
                  return (
                    <S.GroupListContainer>
                      {children({ items })}
                    </S.GroupListContainer>
                  );
                },
                DraggableItem: (props) => {
                  const { items, item, ...rest } = props; // Destructuring items to prevent this spreading to html element

                  return (
                    <S.GroupItemWrapper {...rest}>
                      <div
                        style={{
                          position: "absolute",
                          left: 0,
                          top: 0,
                          width: "100%",
                          height: "100%",
                        }}
                        onClick={() => {
                          navigate(`/exclusive-deal/${item._id}`);
                        }}
                      ></div>
                      <S.GroupItemAction>
                        <S.GroupImage backgroundImg={item?.icon} />
                      </S.GroupItemAction>
                      <S.GroupItemAction className="group-name">
                        <S.GroupName>{item?.name}</S.GroupName>
                      </S.GroupItemAction>
                      <S.GroupItemAction>
                        <Dropdown
                          options={[
                            {
                              label: "แก้ไข",
                              startIcon: <EditRoundedIcon />,
                              onClick: () => {
                                openDialog({
                                  type: "custom",
                                  customDialog: (
                                    <AddGroupDialog
                                      // initialValue={item}
                                      initialValue={{
                                        _id: item?._id,
                                        name: item?.name || "",
                                        icon: item?.icon || "",
                                        icon_hover: item?.icon_hover || "",
                                        banner: item?.banner || "",
                                        position: item?.position || 0,
                                        meta_tag: {
                                          title: item?.meta_tag?.title || "",
                                          desc: item?.meta_tag?.desc || "",
                                          img: item?.meta_tag?.img || "",
                                          // link: "",
                                          keywords:
                                            item?.meta_tag?.keywords || "",
                                        },
                                        product_choice_deals:
                                          item?.product_choice_deals || [],
                                      }}
                                      onClose={() => closeAllDialogs()}
                                      onSuccess={() => {
                                        fetchDeals();
                                        closeAllDialogs();
                                      }}
                                      editable
                                    />
                                  ),
                                });
                              },
                            },
                            {
                              label: "ลบ",
                              startIcon: <DeleteOutlineRoundedIcon />,
                              onClick: () => {
                                openDialog({
                                  type: "confirm",
                                  title: "คุณต้องการลบใช่หรือไม่?",
                                  onConfirm: () => {
                                    handleDeleteGroup(item?._id);
                                    closeDialog();
                                  },
                                  maxWidth: 342,
                                });
                              },
                            },
                          ]}
                        />
                      </S.GroupItemAction>
                    </S.GroupItemWrapper>
                  );
                },
              }}
            />
          </LabelSection>
        </BoxWrapper>

        {/*//* Seller */}
        <BoxWrapper>
          <LabelSection
            title="ร้านค้าที่เข้าร่วม"
            description="คุณสามารถลากร้านค้าเพื่อสลับตำแหน่งได้"
            descIcon={<MoveIcon size={24} />}
            actionMenu={() => (
              <Button
                startIcon={<AddIcon />}
                variant="secondary"
                size="large"
                sx={{
                  minWidth: 200,
                }}
                onClick={() => {
                  openDialog({
                    type: "custom",
                    customDialog: (
                      <AddSellerDialog
                        onClose={() => closeDialog()}
                        onSuccess={() => {
                          fetchDeals();
                          closeAllDialogs();
                        }}
                      />
                    ),
                  });
                }}
              >
                เพิ่มร้านค้า
              </Button>
            )}
          >
            <DraggableBoard
              id="seller-draggable"
              items={sellers}
              onDragEnd={async ({ active, over }) => {
                if (active.id !== over?.id) {
                  const oldIndex = sellers.findIndex(
                    (item) => item._id === active.id,
                  );
                  const newIndex = sellers.findIndex(
                    (item) => item._id === over.id,
                  );

                  const newReArranged = arrayMove(sellers, oldIndex, newIndex);

                  setSellers(newReArranged); // optimistic update

                  try {
                    await moveDealSellerPosition(newReArranged);
                  } catch (err) {
                    setSellers(newReArranged); // if error, revert to original order
                    console.error(err);
                  }
                }
              }}
              Components={{
                DroppableParent: ({ items, children }) => {
                  return (
                    <S.SellerListContainer>
                      {children({ items })}
                    </S.SellerListContainer>
                  );
                },
                DraggableItem: (props) => {
                  const { items, item, ...rest } = props; // Destructuring items to prevent this spreading to html element
                  return (
                    <S.SellerItemWrapper
                      $backgroundImage={item?.seller_id?.profile_image || ""}
                      {...rest}
                    >
                      <S.BannerContainer>
                        <S.BannerItemAction>
                          <IconButton
                            sx={{
                              color: White,
                              backgroundColor: hexToRgba(White, 0.4),
                              padding: "4px",
                            }}
                            onClick={() => {
                              openDialog({
                                type: "confirm",
                                title: "คุณต้องการลบใช่หรือไม่?",
                                onConfirm: () => {
                                  handleDeleteSeller(item?._id);
                                  closeDialog();
                                },
                                maxWidth: 342,
                              });
                            }}
                          >
                            <DeleteOutlineRoundedIcon />
                          </IconButton>
                        </S.BannerItemAction>
                      </S.BannerContainer>
                    </S.SellerItemWrapper>
                  );
                },
              }}
            />
          </LabelSection>
        </BoxWrapper>

        {/* //* Recent */}
        <BoxWrapper>
          <RecentLabel>ล่าสุด</RecentLabel>
          <S.RecentlyContainer>
            {recentlyProducts.slice(0, 8).map((recentlyProduct, index) => {
              const { product_choice_deal: product, ...item } = recentlyProduct;
              return (
                <S.RecentlyItem
                  key={`recently-product-${index}`}
                  onClick={() =>
                    openDialog({
                      type: "custom",
                      customDialog: (
                        <EditProductDialog
                          initialValue={recentlyProduct}
                          dealGroups={dealGroups}
                          onClose={() => closeAllDialogs()}
                          onSuccess={() => {
                            fetchDeals();
                            closeAllDialogs();
                          }}
                        />
                      ),
                    })
                  }
                >
                  <Stack
                    flexDirection="row"
                    alignItems="center"
                    gap={2}
                    sx={{
                      width: "20%",
                      maxWidth: "200px",
                      "&:hover": {
                        background: "var(--lightgrey-color)",
                      },
                    }}
                  >
                    <S.RecentlyPreviewImage>
                      {!!product?.group_image?.product_display_image ===
                      false ? (
                        <ImageEmpty>
                          <InsertPhotoIcon
                            sx={{
                              color: "rgba(0, 0, 0, 0.54)",
                              cursor: "pointer",
                            }}
                          />
                        </ImageEmpty>
                      ) : (
                        <S.PreviewImage
                          src={
                            product?.group_image?.product_display_image
                              ? product?.group_image?.product_display_image.replace(
                                  ".com",
                                  ".com/300x300",
                                )
                              : ""
                          }
                          alt=""
                        />
                      )}
                    </S.RecentlyPreviewImage>

                    <Box>
                      <S.RecentlyText color={Black}>
                        {product?.product?.item_name}
                      </S.RecentlyText>
                      <S.RecentlyText>
                        {product?.product?.item_code}
                      </S.RecentlyText>
                    </Box>
                  </Stack>

                  <Box sx={{ width: "20%", textAlign: "center" }}>
                    <S.RecentlyText>
                      {product?.product?.user?.seller?.company_name}
                    </S.RecentlyText>
                  </Box>

                  <Box sx={{ width: "20%", textAlign: "center" }}>
                    <S.RecentlyText>{item?.group_id.name}</S.RecentlyText>
                  </Box>

                  <Box sx={{ width: "20%" }}>
                    <S.RecentlyText>
                      {product?.size?.quantity === "size"
                        ? `${product?.size?.width} ${
                            getLocale() === "th"
                              ? product?.size?.unit_width?.unit_th
                              : product?.size?.unit_width?.unit_en
                          } x ${product?.size?.height} ${
                            getLocale() === "th"
                              ? product?.size?.unit_height?.unit_th
                              : product?.size?.unit_height?.unit_en
                          } x ${product?.size?.thickness} ${
                            getLocale() === "th"
                              ? product?.size?.unit_thickness?.unit_th
                              : product?.size?.unit_thickness?.unit_en
                          }`
                        : product?.size?.quantity === "capacity"
                          ? `${product?.size?.capacity_size} ${
                              getLocale() === "th"
                                ? product?.size?.unit_capacity?.unit_th
                                : product?.size?.unit_capacity?.unit_en
                            }`
                          : getLocale() === "th"
                            ? "สินค้าสั่งทำพิเศษ"
                            : "Made by order"}
                    </S.RecentlyText>
                    <S.RecentlyText>
                      (
                      {getLocale() === "th"
                        ? product?.color?.color_th
                        : product?.color?.color_en}
                      )
                    </S.RecentlyText>
                  </Box>

                  <Box sx={{ width: "20%" }}>
                    <Stack
                      flexDirection="row"
                      alignItems="center"
                      justifyContent="flex-end"
                      gap={3}
                    >
                      <S.RecentlyText>ราคาปกติ</S.RecentlyText>
                      <S.RecentlyText color={Black}>
                        {convertPrice(item?.price || 0)}
                      </S.RecentlyText>
                    </Stack>

                    {!!item?.special_price && (
                      <Stack
                        flexDirection="row"
                        alignItems="center"
                        justifyContent="flex-end"
                        gap={3}
                      >
                        <S.RecentlyText>ราคาลด</S.RecentlyText>

                        <S.RecentlyText specialPrice>
                          {convertPrice(item?.special_price || 0)}
                        </S.RecentlyText>
                      </Stack>
                    )}
                  </Box>
                </S.RecentlyItem>
              );
            })}
          </S.RecentlyContainer>
        </BoxWrapper>
      </Main>

      {isLoading && <Loading />}
    </>
  );
}

export default ExclusiveDeal;
